import { DIRECTION_WEST } from "./constants";

export const SPEED_TEST_IMG_SRC = 'https://50k-demo.fra1.cdn.digitaloceanspaces.com/speed.jpg';
export const SPEED_TEST_IMG_SIZE = 10174706;

export const MAIN_VIDEO = 'https://50k-demo.fra1.cdn.digitaloceanspaces.com/videos/main.mp4';
export const MAIN_VIDEO_SLOW = 'https://50k-demo.fra1.cdn.digitaloceanspaces.com/2560×1440/videos/main.mp4';
export const MAIN_VIDEO_MOBILE = 'https://50k-demo.fra1.cdn.digitaloceanspaces.com/mobile/videos/main.mp4';
export const MAIN_DIRECTION = DIRECTION_WEST;